<template>
    <LoginContainer :buttons="button" :errorMessage="errorMessage" :goToRoutes="goToRoute" :logo="logo"
        @submit="createUser" :title="$t('register')">
        <template #form>
            <InputContent name="name" :label="consumer == null ? $t('worker') : $t('consumer')" placeholder=""
                v-model="entityName" type="text" :disabled="true" />
            <InputContent name="name" :label="$t('displayName')" placeholder="" v-model="name" type="text" />
            <InputContent name="email" :label="$t('email')" placeholder="" v-model="email" type="email" />
            <InputContent name="newPassword" :label="$t('password')" placeholder="" v-model="password"
                type="password" />
            <InputContent name="confirmNewPassword" :label="$t('confirmPassword')" placeholder=""
                v-model="confirmPassword" type="password" />
            <p class="message-email">{{ userCreated }}</p>
        </template>
    </LoginContainer>
</template>

<script>
import LoginContainer from '@/components/login/Login.vue';
import InputContent from '@/components/inputs/Content.vue';
import devLogo from "@/assets/logos/dev-logo.png"

export default {
    name: 'RegisterView',
    components: {
        LoginContainer,
        InputContent,
    },
    data() {
        return {
            email: '',
            name: '',
            password: '',
            confirmPassword: '',
            userCreated: '',
            goToRoute: [
                {
                    route: '/',
                    text: 'Volte para a página principal'
                },
            ],
            button: [
                {
                    text: this.$t('register'),
                    type: 'submit',
                }
            ],
            projectId: null,
        }
    },
    methods: {
        async createUser() {
            if (this.password !== this.confirmPassword) {
                return
            }
            await this.$store.dispatch('users/register', {
                name: this.name,
                email: this.email,
                password: this.password,
                consumerId: this.consumerId,
                workerId: this.workerId,
            })
        },
    },
    computed: {
        consumer() {
            if (this.consumerId == null) {
                return null
            }
            return this.$store.getters['consumers/id'](this.consumerId)
        },
        consumerId() {
            return this.$route.query.c
        },
        entityName() {
            if (this.consumer) {
                return this.consumer.name
            }
            if (this.worker) {
                return this.worker.name
            }
            return ""
        },
        logo() {
            if (this.$store.state.instance.logo == null) {
                return devLogo
            }
            return this.$store.state.instance.logo
        },
        errorMessage() {
            if (this.password !== this.confirmPassword) {
                return `${this.$t('password', 2)} não coincidem`
            }
            switch (this.$store.state.users.errorCode) {
                case 'auth/weak-password':
                    return `${this.$t('password')} demasiado fraca`
                case null:
                    return null
            }
            return 'Algo de errado ocorreu. Tente mais tarde'
        },
        worker() {
            if (this.workerId == null) {
                return null
            }
            return this.$store.getters['workers/id'](this.workerId)
        },
        workerId() {
            return this.$route.query.w
        },
        currentUser() {
            return this.$store.state.users.currentUser
        },
    },

    watch: {
        consumer: {
            immediate: true,
            handler() {
                if (this.consumer == null) {
                    return
                }
                this.email = this.consumer.email
            },
        },
        consumerId: {
            immediate: true,
            handler() {
                if (this.consumerId == null) {
                    return
                }
                this.$store.dispatch('consumers/get', this.consumerId)
            },
        },
        currentUser: {
            immediate: true,
            handler() {
                if (this.currentUser != null) {
                    this.$router.push("/")
                }
            }
        },
        worker: {
            immediate: true,
            handler() {
                if (this.worker == null) {
                    return
                }
                this.email = this.worker.email
            },
        },
        workerId: {
            immediate: true,
            handler() {
                if (this.workerId == null) {
                    return
                }
                this.$store.dispatch('workers/get', this.workerId)
            },
        },
    },
}
</script>

<style lang="scss" scoped>
@import '@/assets/utilities/_variables.scss';

.message-email {
    margin-left: 10px;
    color: var(--success-color);
    font-weight: bold;
}

.link {
    margin-left: 10px;

    &:visited {
        color: var(--text-color);
        text-decoration: none;
    }

    &:link {
        text-decoration: none;
    }
}
</style>
